import React, { FC, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { EtaUser } from '@eta/components';
import './Home.scss';
import MarkDown from '../../ContentManagement/Components/MarkDown';
import { MarkDownType } from '../../common/config/constants';
import { authService } from '../../Security/Security';
import { PublicLayout } from '../../common/layout/PublicLayout';

export const AnonymousHome: FC = () => {
    const [currentUser, setCurrentUser] = useState<EtaUser>();

    authService.onCurrentUserLoaded = (user: EtaUser) => {
        setCurrentUser(user);
    };

    if (!currentUser) {
        return (
            <PublicLayout>
                <MarkDown Type={MarkDownType.Full} />
            </PublicLayout>
        );
    }
    return (<Redirect to='/home' />);

};